export default __webpack_public_path__ + "static/Monogatari-16b20672d5337c6a3c6e90b35d344c89.pdf";